// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Asskf","field":"styles_field__25RXL","fieldCol":"styles_fieldCol__3n1hy","diffCol":"styles_diffCol__v7QZ8","diff":"styles_diff__LtL_O"};